import * as Sentry from '@sentry/browser'
import { getCookie } from '@/Helpers/methods'

const getCsrfToken = () => {
    const encryptedToken = getCookie('XSRF-TOKEN')

    return decodeURIComponent(encryptedToken)
}

export const post = async (
    url,
    data,
    { headers = {}, withCsrfToken = true, ...options } = {}
) => {
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            ...(withCsrfToken ? { 'X-XSRF-TOKEN': getCsrfToken() } : {}),
            ...headers,
        },
        body: JSON.stringify(data),
        ...options,
    })

    const parsed = await response.json()

    if (response.status === 419) {
        window.location.assign(route('login'))
        return
    }

    if (!response.ok) {
        Sentry.setContext('request_body', data)
        throw Error(JSON.stringify(parsed))
    }

    return parsed
}

export const put = async (
    url,
    data,
    { headers = {}, withCsrfToken = true, ...options } = {}
) => {
    const response = await fetch(url, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            ...(withCsrfToken ? { 'X-XSRF-TOKEN': getCsrfToken() } : {}),
            ...headers,
        },
        body: JSON.stringify(data),
        ...options,
    })
    const parsed = await response.json()

    if (response.status === 419) {
        window.location.assign(route('login'))
        return
    }

    if (response.status === 422) {
        Sentry.setContext('request_body', data)
        throw Error(JSON.stringify({ status: 422, errors: parsed.errors }))
    }

    if (!response.ok) {
        Sentry.setContext('request_body', data)
        throw Error(JSON.stringify(parsed))
    }

    return parsed
}

export const patch = async (
    url,
    data,
    { headers = {}, withCsrfToken = true, ...options } = {}
) => {
    const response = await fetch(url, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            ...(withCsrfToken ? { 'X-XSRF-TOKEN': getCsrfToken() } : {}),
            ...headers,
        },
        body: JSON.stringify(data),
        ...options,
    })
    const parsed = await response.json()

    if (response.status === 419) {
        window.location.assign(route('login'))
        return
    }

    if (!response.ok) {
        Sentry.setContext('request_body', data)
        throw Error(JSON.stringify(parsed))
    }

    return parsed
}

export const deleteMethod = async (
    url,
    { headers = {}, withCsrfToken = true, ...options } = {}
) => {
    const response = await fetch(url, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            ...(withCsrfToken ? { 'X-XSRF-TOKEN': getCsrfToken() } : {}),
            ...headers,
        },
        ...options,
    })

    if (response.status === 419) {
        window.location.assign(route('login'))
        return
    }

    if (!response.ok) {
        throw Error('The request failed.')
    }

    return response
}

export default {
    put,
    post,
    patch,
    delete: deleteMethod,
}
